import PropTypes from "prop-types"
import Button from "./Button";
const Container = ({children,className=""}) => {
    return <div className={`mx-auto w-11/12 lg:w-9/12 xl:w-8/12 ${className}`}>{children}</div>
}
Button.propTypes = {
    fluid:PropTypes.bool,
    className: PropTypes.string}

export default Container;